import { CarBrand, defaultCarBrand } from "./carBrand";

export interface BrandDiscount {
    id: string;
    createdAt: string;
    updatedAt: string | null;
    deletedAt: string | null;
    workshopSalesDiscount: string;
    storeDiscount: string;
    carBrand: CarBrand | null;
    carBrandId: string;
}

export const defaultBrandDiscount: BrandDiscount = {
    id: '',
    createdAt: '',
    updatedAt: null,
    deletedAt: null,
    workshopSalesDiscount: "0",
    storeDiscount: "0",
    carBrand: defaultCarBrand,
    carBrandId: defaultCarBrand.id,
};